import { render, staticRenderFns } from "./ReturnedPackageHistory.vue?vue&type=template&id=09e690de&"
import script from "./ReturnedPackageHistory.vue?vue&type=script&lang=js&"
export * from "./ReturnedPackageHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports